import { Outlet } from "react-router";
import BackgroundSync from "../components/background/BackgroundSync";
import WebBackButton from "../components/web-back-button";
import LinkEmailPromptGate from "../components/link-email-prompt/LinkEmailPromptGate";
import LinkTelegramPromptGate from "../components/link-telegram-prompt/LinkTelegramPromptGate";

/** Основное приложение внутри `.app-frame` (не login). */
function AppChrome() {
  return (
    <div className="app-frame">
      <BackgroundSync />
      <WebBackButton />
      <LinkEmailPromptGate />
      <LinkTelegramPromptGate />
      <header className="App-header" />
      <div className="content-page">
        <Outlet />
      </div>
    </div>
  );
}

export default AppChrome;
